import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { InventorySubTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  InventorySubTypeCreateDto,
  InventorySubTypeDto,
  InventorySubTypeExcelDownloadDto,
  InventorySubTypeUpdateDto,
} from '../proxy/planning/dtos/inventory-sub-type';
import { INVENTORYSUBTYPE_CONFIG, INVENTORYSUBTYPE_FIELDS } from './inventory-sub-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-inventory-sub-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, InventorySubTypeService, ConfirmationService],
  templateUrl: './inventory-sub-type.html',
  styleUrl: './inventory-sub-type.scss',
})
export class InventorySubType extends BaseCrudComponent<
  InventorySubTypeDto,
  InventorySubTypeCreateDto,
  InventorySubTypeUpdateDto,
  InventorySubTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(InventorySubTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('InventorySubType', ids),
  };
  config = INVENTORYSUBTYPE_CONFIG;
  fields = INVENTORYSUBTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: InventorySubTypeDto): InventorySubTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      inventoryTypeId: data.inventoryTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'InventorySubType';
  }
}
